import { Zap } from "lucide-react";
import { SERVICES } from "./Services";

export default function Marquee() {
  const row = [...SERVICES, ...SERVICES];
  return (
    <div className="relative overflow-hidden border-y border-slate-900/10 bg-surface/60 py-5" data-testid="trust-marquee">
      <div className="animate-marquee flex w-max items-center gap-12 hover:[animation-play-state:paused]">
        {row.map((s, i) => (
          <span
            key={i}
            className="flex items-center gap-12 font-display text-sm font-semibold uppercase tracking-[0.25em] text-slate-500"
          >
            {s.title}
            <Zap className="h-3.5 w-3.5 text-electric" fill="currentColor" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-obsidian to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-obsidian to-transparent" />
    </div>
  );
}
